
import { 
  collection, 
  getDocs, 
  query, 
  where
} from "firebase/firestore";
import { db } from "../config";

export const getTransfersByFamilyId = async (familyId: string) => {
  try {
    const q = query(
      collection(db, "transfers"),
      where("familyId", "==", familyId)
    );
    
    const querySnapshot = await getDocs(q);
    const transfers = querySnapshot.docs.map(doc => ({ 
      id: doc.id, 
      ...doc.data() 
    }));
    
    // Sort by creation date in JavaScript
    return transfers.sort((a: any, b: any) => {
      if (!a.createdAt || !b.createdAt) return 0;
      return b.createdAt.seconds - a.createdAt.seconds;
    });
  } catch (error) {
    console.error("Error getting transfers: ", error);
    throw error;
  }
};

export const getTransfersByUserId = async (userId: string) => {
  try {
    const q = query(
      collection(db, "transfers"),
      where("fromUserId", "==", userId)
    );
    
    const querySnapshot = await getDocs(q);
    const fromTransfers = querySnapshot.docs.map(doc => ({ 
      id: doc.id, 
      ...doc.data() 
    }));

    // Also get transfers where user is the recipient
    const q2 = query(
      collection(db, "transfers"),
      where("toUserId", "==", userId)
    );
    
    const querySnapshot2 = await getDocs(q2);
    const toTransfers = querySnapshot2.docs.map(doc => ({ 
      id: doc.id, 
      ...doc.data() 
    }));

    // Combine and sort by creation date in JavaScript
    const allTransfers = [...fromTransfers, ...toTransfers];
    return allTransfers.sort((a: any, b: any) => {
      if (!a.createdAt || !b.createdAt) return 0;
      return b.createdAt.seconds - a.createdAt.seconds;
    });
  } catch (error) {
    console.error("Error getting user transfers: ", error);
    throw error;
  }
};
